/**
 * Convenience hook wrapping AuthContext with sign-in/sign-out actions.
 */
import { useCallback, useState } from 'react';
import { useAuthContext } from '@/app/providers/AuthProvider';
import { auth } from '@/lib/ezhard';

export function useAuth() {
  const { user, loading, error } = useAuthContext();
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState<Error | null>(null);

  const login = useCallback(async () => {
    setActionLoading(true);
    setActionError(null);
    try {
      await auth.signInWithGoogle();
    } catch (err) {
      setActionError(err instanceof Error ? err : new Error('Sign-in failed'));
    } finally {
      setActionLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    setActionLoading(true);
    setActionError(null);
    try {
      await auth.signOut();
    } catch (err) {
      setActionError(err instanceof Error ? err : new Error('Sign-out failed'));
    } finally {
      setActionLoading(false);
    }
  }, []);

  return {
    user,
    loading: loading || actionLoading,
    error: error || actionError,
    isAuthenticated: !!user,
    login,
    logout,
  };
}
